import ProMember from "./ProMember";
import CommunityMember from "./CommunityMember";
import CommunityPanel from "./CommunityPanel";
import ProPanel from "./ProPanel";
import NoResultsPanel from "./NoResultsPanel";
import ResultsLoading from "./ResultsLoading";
import ProjectSupportPanel from "./ProjectSupportPanel";

import React, { useState, useEffect } from "react";
import { connectHits } from "react-instantsearch-dom";
const Hits = ({ hits }) => {

  const [hasCommunity, setHasCommunity] = React.useState(false);
  const [hasPros, setHasPros] = React.useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const p_array = ['Individuals', 'Companies', 'Manufacturers Suppliers'];
  const c_array = ['Community Members'];

  useEffect(() => {
    let p = hits.some(function(el) {
        console.log('ell', el);
        if(Array.isArray(el.directory_user_type)) {
            return p_array.some(v => el.directory_user_type.includes(v));
        }
        return p_array.includes(el.directory_user_type);
    });
    setHasPros(p);
    let c = hits.some(function(el) {
      return c_array.includes(el.directory_user_type);
    });
    setHasCommunity(c);

    if (hits.length > 0) {
      setIsLoading(false);
    } else {
      let timer = setTimeout(() => setIsLoading(false), 3000);
      return () => {
        clearTimeout(timer);
      };
    }

  });

  const community_members = hits.filter(h => h.directory_user_type === 'Community Members');


  return (
      <React.Fragment>
        {isLoading && <ResultsLoading /> }
        {hasPros === true && <ProPanel hits={hits} />}
        {hasPros === false && <NoResultsPanel />}
        <ProjectSupportPanel />
        {hasCommunity === true && <CommunityPanel hits={community_members} />}
      </React.Fragment>
  );
};

const ResultsPanel = connectHits(Hits);
export default ResultsPanel;
